import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'

const alertMetadata = {

	i18nKeys: {
		'score-changed': 'alerts.scoreChange',
		'comment-added': 'alerts.commentsAdded',
		'metric-value-changed': 'alerts.metricValueChange',
		'change-published': 'alerts.published',

		'greater-than-or-equals': 'alerts.above.withArg',
		'equals': 'alerts.equalTo.withArg',
		'less-than-or-equals': 'alerts.below.withArg'
	},

	/** DomainType to i18n code for deleted domain objects */
	deletedCodes: {
		'scorecard-item': 'alerts.deletedScorecardObject',
		'initiative': 'alerts.deletedInitiative',
		'dashboard': 'alerts.deletedDashboard',
		'strategy-map': 'alerts.deletedStrategyMap',
		'report': 'alerts.deletedReport',
		'briefing': 'alerts.deletedBriefing'
	},

	scoreComparisons: {
		'less-than-or-equals': 'alerts.below',
		'greater-than-or-equals': 'alerts.above',
		'equals': 'alerts.equalTo'
	},

	sendAlertWhenKeys: {
		'score-changed': 'alerts.sendAnAlertWhen',
		'metric-value-changed': 'alerts.sendAnAlertWhenMetric',
		'comment-added': 'alerts.sendAnAlertWhenComment'
	},

	types: {
		COMMENT_ADDED: 'comment-added',
		METRIC_VALUE_CHANGED: 'metric-value-changed',
		METRIC_VALUE_REQUIRES_APPROVAL: 'metric-value-requires-approval',
		METRIC_VALUES_REVIEWED: 'metric-values-reviewed',
		SCORE_CHANGED: 'score-changed',
		BROADCAST: 'broadcast',
		EXPORT_READY: 'export-ready',
		EXPORT_FAILED: 'export-failed',
		SCHEDULED_EXPORT: 'scheduled-export',
		CHANGE_PUBLISHED: 'change-published',
		ACCOUNT_CHANGED: 'account-changed',
		ACCOUNT_DISABLED: 'account-disabled',
		FORM_ALERT: 'form-alert'
	},

	targetByAlertType: {
		// All alerts relating to scorecard nodes are handled in getDomainLabel
		'comment-added': 'common.note.note',
		'comment-replied-to': 'common.note.note',
		'child-source-updated': 'scorecards.scorecardNode',
		'initiative-changed': 'initiatives.initiative',
		'initiative-user-assigned.added': 'initiatives.initiative',
		'initiative-user-assigned.removed': 'initiatives.initiative',
		'initiative-group-assigned.added': 'initiatives.initiative',
		'initiative-group-assigned.removed': 'initiatives.initiative',
		'expenditure-created': 'initiatives.initiative',
		'expenditure-changed': 'initiatives.initiative',
		'expenditure-deleted': 'initiatives.initiative'
	},


	/**
	 * Used to build the confirmation message:
	 * Would you like to change to {new period} for {target label}
	 * @param {String} alertType alert.type (e.g. 'comment-added')
	 */
	getDomainLabel(alertType, itemType) {
		let key = 'scorecards.node.metric'
		if (this.targetByAlertType[alertType]) {
			key = this.targetByAlertType[alertType]
		}
		// #22079 'score-change' alerts shouldn't refer to all Scorecard Items as the default 'KPI'
		if (alertType === 'score-changed' && itemType != 'metric') {
			key = 'scorecards.scorecardNode'
		}
		return i18n.get(key)
	},

	/**
	 * Based on alert type get alert dialog header and banner descriptions.
	 * (Admin -> My Alerts)
	 *
	 * @param {String} type The type of alert use alertMetadata.types
	 * @param {String} domainType
	 * @param {Boolean} isNew
	 * @return {header, description}
	 */
	getI18nDialogLabels(type, domainType, isNew) {
		switch (type) {
			case this.types.SCORE_CHANGED: return {
				header: isNew ? 'alerts.addScoreChangeSubscription' : 'alerts.editScoreChangeSubscription',
				description: 'alerts.scoreChange.formDescription'
			}
			case this.types.METRIC_VALUE_CHANGED: return {
				header: isNew ? 'alerts.addMetricValueChangeSubscription' : 'alerts.editMetricValueChangeSubscription',
				description: 'alerts.metricValueChange.formDescription'
			}
			case this.types.COMMENT_ADDED: return {
				header: isNew ? 'alerts.addCommentSubscription' : 'alerts.editCommentSubscription',
				description: 'alerts.commentsAdded.formDescription'
			}
			case this.types.CHANGE_PUBLISHED: return {
				header: i18n.get(
					isNew ? 'alerts.addPublishedSubscription' : 'alerts.editPublishedSubscription',
					i18n.get(metadata[domainType].singularCode)),
				description: i18n.get(
					'alerts.published.formDescription',
					_.toLower(i18n.get(metadata[domainType].singularCode)))
			}
		}
	}
}

const scoreComparisonOptionHtml = _.memoize(() => {
	return _.reduce(alertMetadata.scoreComparisons, (html, i18nKey, value) => {
		return html += `<option value="${value}">${i18n.get(i18nKey)}</option>`
	},'')
})

export default alertMetadata
export { scoreComparisonOptionHtml }
alertMetadata.__filename__ = 'alerts/alert-metadata.js'
